<template>
    <h2>Hello World from OmniSearch! (Scholarship search)</h2>
</template>